import { createRecipe } from './runtime';

const inputConfig = {"name":"input","defaultVariants":{"size":"md"},"variantMap":{"size":["2xl","2xs","lg","md","sm","xl","xs"]}}

export const input = /* @__PURE__ */ createRecipe(inputConfig)